class ViewSDKClient {
    constructor() {
        this.readyPromise = new Promise((resolve) => {
            if (window.AdobeDC) {
                resolve();
            } else {
                document.addEventListener("adobe_dc_view_sdk.ready", () => {
                    resolve();
                });
            }
        });
        this.adobeDCView = undefined;
    }
    ready() {
        return this.readyPromise;
    }

    applicantId = 0;
    token = '';
    agencyKey = '';
    fileName = '';

    base64ToArrayBuffer(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    };

    previewFile(divId, viewerConfig, base64Data, fileName, appId, tkn, akey) {
        this.applicantId = appId;
        this.token = tkn;
        this.agencyKey = akey;
        this.fileName = fileName;

        const config = {
            clientId: process.env.REACT_APP_ADOBE_DEV_CLIENT_ID,
        };
        if (divId) {
            config.divId = divId;
        }
        this.adobeDCView = new window.AdobeDC.View(config);

        const previewFilePromise = this.adobeDCView.previewFile(
            {
                content: {
                    promise: Promise.resolve(this.base64ToArrayBuffer(base64Data))
                },
                metaData: {
                    fileName: fileName
                },
            },
            viewerConfig
        );
        return previewFilePromise;
    }

    previewFileUsingFilePromise(divId, filePromise, fileName) {
        this.adobeDCView = new window.AdobeDC.View({
            clientId: process.env.REACT_APP_ADOBE_DEV_CLIENT_ID,
            divId,
        });
        this.adobeDCView.previewFile(
            {
                content: {
                    promise: filePromise,
                },
                metaData: {
                    fileName: fileName,
                },
            },
            {}
        );
    }

    registerSaveApiHandler() {

        const saveApiHandler = (metaData, content, options) => {
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    FileName: this.fileName,
                    Data: Buffer.from(content).toString('base64')
                })
            }

            let url = `api/DocumentService/${this.agencyKey}/document/upload/${this.applicantId}`;

            fetch(url, requestOptions)
                .then(response => response.json());

            return new Promise((resolve) => {
                setTimeout(() => {
                    const response = {
                        code: window.AdobeDC.View.Enum.ApiResponseCode.SUCCESS,
                        data: {
                            metaData: Object.assign(metaData, {
                                updatedAt: new Date().getTime(),
                            }),
                        },
                    };
                    resolve(response);
                }, 2000);
            });
        };

        this.adobeDCView.registerCallback(
            window.AdobeDC.View.Enum.CallbackType.SAVE_API,
            saveApiHandler,
            {
                autoSaveFrequency: 0,
                enableFocusPolling: false,
                showSaveButton: true
            }
        );
    }

    registerEventsHandler() {
        this.adobeDCView.registerCallback(
            window.AdobeDC.View.Enum.CallbackType.EVENT_LISTENER,
            (event) => {
                console.log(event);
            },
            {
                enablePDFAnalytics: true,
            }
        );
    }

}
export default ViewSDKClient;



// WEBPACK FOOTER //
// ./src/common/ViewSdkClient.js